<template>
  <div class="all">
    <div class="title">
      <p>Not found /</p>
      <p>Não achei</p>
    </div>

    <navi-button mode="middle"></navi-button>
  </div>
</template>

<style scoped>
.all {
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--color-primary-1);
  width: 100vw;
  height: 100vh;
  z-index: 2000;
  color: var(--color-grey-4);
}

.title {
  margin: 20% 10%;
  text-align: center;
}

p {
  font-family: var(--font-primary);
  font-size: 8rem;
}
</style>
